<template>
    <div id="withdraw-03">
        <div id="processed-popup" class="popup" :class="{ 'is-active': isFinalWithdrawFlow }">
            <div class="overlay"></div>
            <div class="popup-body d-flex justify-content-center align-items-center pr-4 pl-4">
                <div class="card">
                    <div class="card-body text-center pt-4 pb-4">
                        <div class="text-center p-2">
                            <h3 class="font-weight-light">ระบบได้รับคำขอแล้วจะดำเนินการโอนเงินเข้าสู่บัญชีที่ท่านผูกไว้กับเรา ภายในเวลา 30 นาที</h3>
                        </div>
                        <div class="d-none img-container text-center mb-3 mt-3">
                            <img :src="$util.asset('goobank_assets/assets/avatar/too_avatar.jpg')" />
                        </div>
                        <a class="btn btn-primary btn-lg btn-block mt-3" :href="$util.url('member/home')">กลับสู่หน้าหลัก</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="container pt-4">
            <div class="card shadow-lg">
                <div class="card-body text-center pt-4 pb-4">
                    <div v-if="isPreProcessing" class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <template v-else>
                        <p class="h3 font-weight-light mt-4">ท่านต้องการถอนเงินออกจากบัญชีจำนวน</p>
                        <p class="h3 font-weight-light mt-4 mb-0">{{request.withdrawAmount | money}} บาท</p>
                        <p class="h6 font-weight-light text-secondary opacity-80">ค่าธรรมเนียม {{fee | money}} บาท</p>
                        <p class="h3 font-weight-light mt-4 mb-0">ยอดเงินคงเหลือ</p>
                        <p class="h3 font-weight-light mt-2 mb-4">{{$currency(walletAmount).subtract(request.withdrawAmount).subtract(fee) | money}} บาท</p>
                    </template>
                </div>
            </div>
        </div>
        <div class="stick-down-pusher"></div>
        <div class="stick-down p-4">
            <button :disabled="isPreProcessing || isProcessing" class="btn btn-primary btn-lg btn-block" @click="confirmWithdrawRequest()">ยืนยันการถอนเงิน</button>
            <button :disabled="isPreProcessing || isProcessing" class="btn btn-light btn-lg btn-block" @click="cancelWithdrawRequest()">ยกเลิก</button>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        isPreProcessing: true,
        isProcessing: false,
        isFinalWithdrawFlow: false,
        walletAmount: 0,
        fee: 0,
        request: {
            requestId: '',
            withdrawAmount: '',
            expire: ''
        }
    }),
    async created () {
        try {
            const result = await this.$api.withdraw.getUserCurrentStep()
            const data = result.data;
            if (data.step !== 'WAIT_USER_CONFIRM')
                this.$router.replace({
                    name: 'withdraw-01'
                });
            const feeResult = await this.$api.withdraw.fee(data.request.withdrawAmount)
            const walletResult = await this.$api.wallet.get()
            this.request = result.data.request;
            this.fee = feeResult.data.fee
            this.walletAmount = walletResult.data.current_money
            this.isPreProcessing = false;
        } catch (error) {
            console.error(error);
        }
    },
    methods: {
        async cancelWithdrawRequest () {
            this.isProcessing = true
            try {
                await this.$api.withdraw.cancel(this.request.requestId)
                this.$router.replace({ name: 'withdraw-01' })
            } catch (error) {
                console.error(error)
            }
        },
        async confirmWithdrawRequest () {
            this.isProcessing = true
            try {
                const result = await this.$api.withdraw.confirm(this.request.requestId)
                const data = result.data
                if (data.success) {
                    this.isFinalWithdrawFlow = true
                }
            } catch (error) {
                console.error(error)
            }
        }
    }
}
</script>

<style lang="scss">

</style>
